import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NotificationsService } from 'angular2-notifications';

@Injectable()
export class NotifyService {

    noteParams: any;
    noteTypes: any;

    constructor(private notificationsService: NotificationsService, private _translate: TranslateService,
    ) {

        this.noteParams = { type: '', title: '', content: '' };
        this.noteTypes = ['success', 'error', 'alert', 'warn', 'info', 'bare'];
    }

    notify(data: NotifyModel) {

        //console.log('NotifyService notify', data, this.noteTypes.indexOf(data.type));

        if (data && data.hasOwnProperty('type') && this.noteTypes.indexOf(data.type) !== -1) {

            const params = Object.assign({}, this.noteParams, data);

            // set params vaule or translated
            if (params.title) {
                let translated = this._translate.instant(params.title);
                if (translated) params.title = translated;
            }

            if (params.content) {
                let translated = this._translate.instant(params.content);
                if (translated) params.content = translated;
            }

            // otherwise set defaults
            if (!params.title) params.title = this._translate.instant('notify_default_title_' + params.type);
            if (!params.content) params.content = this._translate.instant('notify_default_content_' + params.type);

            //console.log('NotifyService notify - Params', params);

            return (this.notificationsService.create(params.title, params.content, params.type)) ? true : false;
        }
        return false;
    }

    success(content: string = '', title: string = '') {

        let data = { type: 'success' };

        if (content) data['content'] = content.trim();
        if (title) data['title'] = title.trim();
        const params = Object.assign({}, this.noteParams, data);
        return this.notify(params);
    }

    error(content: string = '', title: string = '') {

        let data = { type: 'error' };

        if (content) data['content'] = content.trim();
        if (title) data['title'] = title.trim();
        const params = Object.assign({}, this.noteParams, data);
        return this.notify(params);
    }

    warning(content: string = '', title: string = '') {

        let data = { type: 'warn' };

        if (content) data['content'] = content.trim();
        if (title) data['title'] = title.trim();
        const params = Object.assign({}, this.noteParams, data);
        return this.notify(params);
    }

    info(content: string = '', title: string = '') {

        let data = { type: 'info' };

        if (content) data['content'] = content.trim();
        if (title) data['title'] = title.trim();
        const params = Object.assign({}, this.noteParams, data);
        return this.notify(params);
    }

    alert(content: string = '', title: string = '') {

        let data = { type: 'alert' };

        if (content) data['content'] = content.trim();
        if (title) data['title'] = title.trim();
        const params = Object.assign({}, this.noteParams, data);
        return this.notify(params);
    }

}

export interface NotifyModel {
    type: string;
    title: string;
    content: string;
};

